module.exports = __webpack_public_path__ + "static/media/nftearth.30a87b4e.png";